import ns from '../../utilities/namespace.js';

const InstanceEvent = {
  CLICK: ns.event('click')
};

export { InstanceEvent };
